/* src/app/front-layout/common/header/header.component.css */
.bookfreeDemo {
  background: #f37022;
  border-radius: 13px !important;
  border: 1px solid #f37022 !important;
  padding: 3px 12px;
}
.sublist,
.sublist2 {
  padding: 0px 10px;
  display: none;
}
.secondMenu:hover .sublist2 {
  display: block;
}
.firstMenu:hover .sublist {
  display: block;
}
.hlight {
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #8f00ff,
      #ff0057);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine 5s linear infinite;
}
@keyframes shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.hl-img {
  width: 18px;
  height: 18px;
}
/*# sourceMappingURL=header.component.css.map */
